<template>
  <div class="cpt-introduce">
    <div :class="$utils.isMobile() ? 'introduce-m' : 'introduce'">
      <div class="title-en tit-en" v-if="$i18n.locale == 'zh-CN'">{{ introduceData.titleEn }}</div>
      <div class="title tit">{{ introduceData.title }}</div>
      <div class="text-box">{{ introduceData.text }}</div>
      <div class="tab-box">
        <el-table
          :data="introduceData.tableData"
          :border="true"
          style="width: 100%"
          :header-row-class-name="$i18n.locale == 'en-US' ? 'header-item-en' : 'header-item'"
          :row-class-name="$i18n.locale == 'en-US' ? 'row-item-en' : 'row-item'"
        >
          <el-table-column
            v-for="item in introduceData.tableLable"
            :key="item.id"
            :prop="item.name"
            :label="item.label"
            :width="$utils.isMobile() ? '115' : '400'"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cpt-introduce',
  data() {
    return {
      introduceData: this._contentData.introduceData
    }
  },

  methods: {

  },
}

</script>

<style lang='scss' scoped>
.cpt-introduce{
  width: auto;
  .introduce{
    width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px;
    .tit-en{
      color: rgba(51, 51, 51, 0.3);
      // text-align: center;
    }
    .tit{
      color: rgba(51, 51, 51, 1);
      // text-align: center;
    }
    .text-box{
      color: rgba(51, 51, 51, 1);
      font-size: 26px;
      // font-family: MiSans-Regular;
    }
    .tab-box{
      padding-top: 30px;
    }
  }
  .introduce-m{
    // width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px;
    .tit-en{
      color: rgba(51, 51, 51, 0.3);
      text-align: center;
    }
    .tit{
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .text-box{
      color: rgba(51, 51, 51, 1);
      font-size: 11px;
      // font-family: MiSans-Regular;
      text-align: center;
    }
    .tab-box{
      padding-top: 10px;
    }
  }
}
</style>

<style>
.introduce .tab-box .header-item th{
  background: #407EA0;
  color: #fff;
  font-size: 28px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  padding: 20px 0;
  height: 105px;
}
.introduce .tab-box .header-item th .cell{
  line-height: normal;
}
.introduce .tab-box .row-item .el-table_1_column_1{
  /* background: #407EA0; */
  color: #333;
  font-size: 28px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  padding: 20px 0;
}
.introduce .tab-box .row-item td{
  /* background: #407EA0; */
  color: #333;
  font-size: 24px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  padding: 0px 30px;
  height: 105px;
}
.introduce .tab-box .row-item td .cell{
  line-height: 30px;
}
.introduce-m .tab-box .header-item th{
  background: #407EA0;
  color: #fff;
  font-size: 10px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  height: 45px;
}
.introduce-m .tab-box .header-item th .cell{
  line-height: normal;
}
.introduce-m .tab-box .row-item .el-table_1_column_1{
  /* background: #407EA0; */
  color: #333;
  font-size: 10px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  padding: 20px 0;
}
.introduce-m .tab-box .row-item td{
  /* background: #407EA0; */
  color: #333;
  font-size: 8px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  height: 45px;
}
.introduce-m .tab-box .row-item td .cell{
  line-height: 10px;
}

.introduce .tab-box .header-item-en th{
  background: #407EA0;
  color: #fff;
  font-size: 20px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  padding: 20px 0;
  height: 105px;
}
.introduce .tab-box .header-item-en th .cell{
  line-height: normal;
}
.introduce .tab-box .row-item-en .el-table_1_column_1{
  /* background: #407EA0; */
  color: #333;
  font-size: 20px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  padding: 20px 0;
}
.introduce .tab-box .row-item-en td{
  /* background: #407EA0; */
  color: #333;
  font-size: 18px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  padding: 0px 30px;
  height: 105px;
}
.introduce .tab-box .row-item-en td .cell{
  line-height: 30px;
}
.introduce-m .tab-box .header-item-en th{
  background: #407EA0;
  color: #fff;
  font-size: 10px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  height: 45px;
}
.introduce-m .tab-box .header-item-en th .cell{
  line-height: normal;
}
.introduce-m .tab-box .row-item-en .el-table_1_column_1{
  /* background: #407EA0; */
  color: #333;
  font-size: 10px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  padding: 20px 0;
}
.introduce-m .tab-box .row-item-en td{
  /* background: #407EA0; */
  color: #333;
  font-size: 8px;
  /* font-family: MiSans-Medium; */
  text-align: center;
  height: 45px;
}
.introduce-m .tab-box .row-item-en td .cell{
  line-height: 10px;
  letter-spacing: normal;
}
</style>